import React from 'react';
import {Link, useLocation} from 'react-router-dom';
import {FaHistory} from 'react-icons/fa';
import releases from './releases.json';
import '../dashboard/component/DashboardComponent.css';
import './ChangelogPages.css';

export const changelogUrl = (date, id) => `/app/changelog/${date}/${id}`;
export const releaseDate = date => new Date(`${date}T12:00:00`).toLocaleDateString('pl-PL', {day: 'numeric', month: 'long', year: 'numeric'});
const label = type => type === 'feature' ? 'Nowość' : 'Poprawka';

export const ChangelogTile = () => <section className="dashboard-tile changelog-tile" aria-labelledby="changelog-tile-title">
  <div className="dashboard-tile-heading"><FaHistory aria-hidden="true"/><h2 id="changelog-tile-title">Co nowego</h2></div>
  <div className="dashboard-tile-subtitle">Ostatnia zmiana: <time dateTime={releases[0].date}>{releaseDate(releases[0].date)}</time></div>
  <p>{releases[0].summary}</p>
  <Link className="dashboard-more" to="/app/changelog">Więcej →</Link>
</section>;

export const ChangelogPage = () => <main className="dashboard-page changelog-page">
  <nav className="changelog-breadcrumb" aria-label="Nawigacja historii zmian"><Link to="/app/dashboard">Strona główna</Link></nav>
  <div className="dashboard-page-head"><div><h1><FaHistory aria-hidden="true"/> Historia zmian</h1>
    <p>Nowości, poprawki i wskazówki, jak z nich korzystać.</p></div></div>
  <div className="changelog-releases">{releases.map(release => <section className="changelog-release" key={release.date} aria-labelledby={`release-${release.date}`}>
    <h2 id={`release-${release.date}`}><time dateTime={release.date}>{releaseDate(release.date)}</time></h2>
    <p className="changelog-summary">{release.summary}</p>
    <ul className="changelog-changes">{release.changes.map(change => <li key={change.id}>
      <span className={`changelog-kind changelog-kind-${change.type}`}>{label(change.type)}</span>
      <h3><Link to={changelogUrl(release.date, change.id)}>{change.title}</Link></h3>
      <p>{change.description}</p>
      <Link className="changelog-help" to={changelogUrl(release.date, change.id)} aria-label={`Jak korzystać: ${change.title}`}>Jak korzystać →</Link>
    </li>)}</ul>
  </section>)}</div>
</main>;

export const ChangelogDetailPage = () => {
  const {pathname} = useLocation();
  const [, , , date, id] = pathname.split('/');
  const release = releases.find(entry => entry.date === date);
  const change = release?.changes.find(entry => entry.id === id);
  return <main className="dashboard-page changelog-page">
    <nav className="changelog-breadcrumb" aria-label="Nawigacja historii zmian">
      <Link to="/app/dashboard">Strona główna</Link><span aria-hidden="true">/</span><Link to="/app/changelog">Wszystkie zmiany</Link>
    </nav>
    {!change ? <><h1>Nie znaleziono zmiany</h1><p>Wybierz pozycję z historii zmian, aby przeczytać instrukcję.</p></> : <article className="changelog-detail">
      <div className="changelog-detail-meta"><span className={`changelog-kind changelog-kind-${change.type}`}>{label(change.type)}</span>
        <time dateTime={release.date}>{releaseDate(release.date)}</time></div>
      <h1>{change.title}</h1><p>{change.description}</p>
      <h2>Jak korzystać</h2><ol>{change.steps.map(step => <li key={step}>{step}</li>)}</ol>
      {change.note && <p className="changelog-summary">{change.note}</p>}
    </article>}
  </main>;
};
